// Argus — DayJS setup global cu plugin relativeTime + locale RO.

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

// Notă: NU setăm locale RO global momentan — pentru claritate operator + multilingv ulterior,
// folosim formatul EN ("a few seconds ago", "2 hours") implicit.
// Dacă user cere RO, importăm `dayjs/locale/ro` și apelăm dayjs.locale('ro').

export { dayjs };
